import { Idle } from '@ng-idle/core';
import { Endpoints } from 'src/app/shared/config/endpoints';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { ActivatedRoute } from '@angular/router';
import { Component, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import { AppState } from 'src/app/store/app.state';
import { OrgModel } from 'src/app/store/storeModels/user.model';
import { ClientService } from '../services/client-services/clients.service';
import { CLIENT_MODULE_ENUM, customFormField, CUSTOM_FIELDS_TYPES_ENUM } from '../data/clientService.data';
import { GeneralService } from '../services/general.service';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';

@Component({
  selector: "app-customer-survey",
  templateUrl: "./customer-survey.component.html",
  styleUrls: ["./customer-survey.component.css"],
})
export class CustomerSurveyComponent implements OnInit {
  apiUrl = this.endPoint.ticketUrl + "/saveCustomerSatisfaction";
  ticketCode;
  feedbackMsgList = {
    "100":
      "GREAT: Wow. This means a lot to us. Is there anything you would like us to do better?",
    "75": "GOOD: We are glad you enjoyed this service. Please tell us how we can exceed your expectation",
    "50": "OKAY: Thank you for your feedback. Please tell us what we can do differently to earn a more exciting smiley from you.",
    "25": "BAD: We are sorry you didnt enjoy this service. Please tell us how we can improve on this",
    "0": "TERRIBLE: Ouch. We are sorry you had an unpleasant experience. Please tell us how we can serve you better",
  };
  message = "";
  rate: string;
  feedback = "";
  loading = false;
  submitted = false;
  decisionMade = false;
  customSurvey: boolean = false;
  org: OrgModel;
  customFieldControls: Array<customFormField> | [] = [];
  surveyForm: any;
  customFieldsTypesEnum = CUSTOM_FIELDS_TYPES_ENUM;

  config2 = {
    search: false, // true/false for the search functionlity defaults to false,
    placeholder: "Select Option", // text to be displayed when no item is selected defaults to Select,
    limitTo: 10, // a number thats limits the no of options displayed in the UI similar to angular's limitTo pipe
    noResultsFound: "No results found!", // text to be displayed when no items are found while searching
    searchPlaceholder: "search",
  };
  clientLocation: any;

  constructor(
    route: ActivatedRoute,
    private http: HttpClient,
    store: Store<AppState>,
    private genServ: GeneralService,
    private clientService: ClientService,
    private fb: FormBuilder,
    private endPoint: Endpoints
  ) {
    route.params.subscribe((res) => {
      this.ticketCode = res.ticketCode;
    });
    store.select("userInfo").subscribe((info) => {
      this.org = info.organization;
    });
  }

  ngOnInit() {
    this.getLocation();
    this.createForm();
    this.extractCode();
  }

  async extractCode() {
    // for instances where users are not from the organization
    const code = this.ticketCode;
    const OrgID = code.split("-")[1];
    console.log(OrgID);
    await this.getCustomSurvey(OrgID);
  }

  createForm() {
    this.surveyForm = this.fb.group({
      message: ["", Validators.required],
    });
  }

  onKeyDown(event: KeyboardEvent) {
    const isInvalidKey = !(
      event.key.match(/[a-zA-Z\s]/) ||
      event.ctrlKey ||
      event.metaKey ||
      event.altKey
    );
    if (isInvalidKey) {
      event.preventDefault();
    }
  }

  setDecision() {
    if(!this.customFieldControls.length) {
      this.onSubmit();
    } else {
      this.decisionMade = true;
    }
  }

  setYesDecision() {
    this.customSurvey = true;
    this.decisionMade = false;
  }

  getCustomSurvey(id) {
    this.clientService
        .fetchCustomFormFields(id, CLIENT_MODULE_ENUM.survey)
        .subscribe({
            next: (payload: Array<customFormField>) => {
                if (payload.length) {
                    this.customFieldControls = payload;
                    console.log(this.customFieldControls);
                    const customFieldsGroup = this.fb.group({});
                    this.customFieldControls.forEach((field: customFormField) => {
                        const fieldControl = new FormControl("");
                        customFieldsGroup.addControl(String(field.label), fieldControl);
                    });
                    this.surveyForm.addControl("customFields", customFieldsGroup);
                }
            },
            error: (err) => {
                console.error("An error occurred while fetching custom survey fields:", err);
                this.customFieldControls = [];
                // Optionally, you can provide user feedback or handle the error in a more user-friendly way.
                // For example, you could show a toast notification or set an error message in the UI.
                // this.toastr.error('Failed to fetch survey fields. Please try again later.');
            },
            complete: () => {
                console.log(this.customFieldControls);
            }
        });
}


  choseRate(rate) {
    this.rate = rate;
    this.message = this.feedbackMsgList[rate];
  }

  onSubmit() {
    const { message, customFields } = this.surveyForm.value;
    let latitude, longitude, state_prov, country_name, country_flag, city;

    if (this.clientLocation) {
      ({ latitude, longitude, state_prov, country_name, country_flag, city } =
        this.clientLocation);
    }

    const body = {
      ticketCode: this.ticketCode,
      rating: this.rate,
      message: message,
      customFields: customFields,
      latitude: latitude || null,
      longitude: longitude || null,
      state: state_prov || null,
      city: city || null,
      country: country_name || null,
      flag: country_flag || null,
    };

    // Remove properties with null values
    if (body !== null || body !== undefined) {
      Object.keys(body).forEach((key) => {
        if (body[key] === null || body[key] === "" || body[key] === undefined) {
          delete body[key];
        }
      });
    }

    this.loading = true;
    const headers = new HttpHeaders({
      Authorization: "",
    })
    this.http.post(this.apiUrl, body, { headers: headers }).subscribe(res => {
      this.loading = false;
      this.submitted = true;
    }, () => {
      this.loading = false;
    })
  }

  getLocation() {
    this.clientService.fetchCustomerLocation().subscribe((res: any) => {
      this.clientLocation = res;
    });
  }
}
